export const ACTION_IN_PROGRESS = 'ACTION_IN_PROGRESS';
